import React from 'react';

import { link, routes } from '@aline/routes';
import { Helmet } from 'react-helmet';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { createRelativeRouter } from 'src/helpers/router-helpers';
import { makeStyles } from 'tss-react/mui';

import { TemplateList } from './template-list/TemplateList';

const useStyles = makeStyles()(() => ({
  page: {
    display: 'flex',
    height: '100%',
    position: 'relative',
    width: '100%',
  },
}));

const { toRelativePath: toRelativeTemplatePath } = createRelativeRouter(routes.TemplateIndex, {
  nestedRoutes: true,
});

export function TemplatePage() {
  const { classes } = useStyles();
  const location = useLocation();
  return (
    <>
      <Helmet>
        <title>Templates</title>
      </Helmet>
      <div className={classes.page}>
        <Routes location={location.pathname}>
          <Route
            element={<TemplateList key="published" templateType="published" />}
            path={toRelativeTemplatePath(routes.TemplatePublished)}
          />
          <Route
            element={<TemplateList key="draft" templateType="draft" />}
            path={toRelativeTemplatePath(routes.TemplateDraft)}
          />
          <Route element={<Navigate replace to={link.TemplatePublished()} />} path="/" />
        </Routes>
      </div>
    </>
  );
}
